import { FC } from "react";
import { Typography, Link } from "@mui/material";
import { books } from "@/assets/books";
import { styles } from "../stylesSignUp";

interface BottomLinkProps {
  text?: string;
  linkText?: string;
  href?: string;
  sx?: object;
}

const BottomLink: FC<BottomLinkProps> = ({
  text = "Already have an account?",
  linkText = "Log in",
  href = books.login,
  sx,
}) => {
  return (
    <Typography
      fontFamily="Inter"
      lineHeight="24px"
      fontSize="15px"
      fontWeight={500}
      variant="h5"
      align="center"
      sx={{ mt: 4, color: "#52575D", ...sx }}
    >
      {text}{" "}
      <Link href={href} underline="always" color="primary.main" sx={styles.Link}>
        {linkText}
      </Link>
    </Typography>
  );
};

export default BottomLink;
